module.exports = __webpack_public_path__ + "static/media/icons8-trash.30106819.svg";